import { Box, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import LatestsFundsCarousel from './LatestsFundsCarousel';
import { useTranslation } from 'react-i18next';
import testlogo from '../../../assets/testlogo.png';
import { IClosingFund } from '../../../models/Fund';
import closingIcon from '../../../assets/Clock.png'
import closing2Icon from '../../../assets/Wallet.png'
import closing3Icon from '../../../assets/Star.png'
import { useAppDispatch, useAppSelector } from '../../../store/reducers/store';
import { loadCarousel } from '../../../store/actions/libraryOfFunds';

export interface ILatestsFundsProps{
    orientation: 'Horizontal' | 'Vertical'
}

const LatestsFunds: React.FC<ILatestsFundsProps> = ({orientation}) => {
    const { t } = useTranslation();
    const carousel = useAppSelector(state => state.libraryOfFundsReducer.carousel);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (carousel === undefined){
            dispatch(loadCarousel());
        }
    }, [carousel, dispatch]);
    
    // const data1: IClosingFund[] = [
    //     { logo: testlogo, closingIn: 18, name: "Sequoya Kapital Fund I", fondSize: 8000000 },
    //     { logo: testlogo, closingIn: 15, name: "Sequoya Kapital Fund II", fondSize: 7000000 },
    //     { logo: testlogo, closingIn: 29, name: "Sequoya Kapital Fund III", fondSize: 12000000 }
    // ]
    // const data2: IClosingFund[] = [
    //     { logo: testlogo, closingIn: 180000, name: "Sequoya Kapital Fund I", fondSize: 8000000 },
    //     { logo: testlogo, closingIn: 150000, name: "Sequoya Kapital Fund II", fondSize: 7000000 },
    //     { logo: testlogo, closingIn: 290000, name: "Sequoya Kapital Fund III", fondSize: 12000000 }
    // ]

    if (carousel === undefined){
        return <></>;
    }

    return <Box display={"flex"} flexDirection={orientation === 'Horizontal' ? "row" : "column"} gap={orientation === 'Horizontal' ? "66px" : "32px"} width={"100%"}>
        {orientation === 'Vertical' && <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"500"}>{t('DashboardLatestOnFunds')}</Typography>}
        <LatestsFundsCarousel orientation={orientation} type='closingDate' data={carousel.byDate} icon={closingIcon} />
        <LatestsFundsCarousel orientation={orientation} type='closingValue' data={carousel.byValue} icon={closing2Icon}  />
        <LatestsFundsCarousel orientation={orientation} type='comingDate' data={carousel.coming} icon={closing3Icon}  />
    </Box>;
}

export default LatestsFunds;